import '../../scss/press.scss';

require('@fancyapps/fancybox');

const $ = require('jquery');

$(document).ready(function () {
    $().fancybox({
        selector: '.item-image',
        toolbar: false,
        wheel: false
    });
});
